import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import useIsMobile from '../hooks/useIsMobile';
import api from '../services/api';

function Registro() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const isMobile = useIsMobile();
  const [searchParams] = useSearchParams();
const registroExitoso = searchParams.get('registro') === 'exitoso';
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (formData.password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    const telefonoLimpio = (formData.telefono || '').replace(/\D/g, '');
    if (telefonoLimpio.length !== 10) {
      setError('El teléfono es obligatorio y debe tener 10 dígitos.');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/registro', {
        nombre: formData.nombre,
        email: formData.email,
        telefono: telefonoLimpio,
        password: formData.password
      });
      
      // Auto-login after registration
      const result = await login(formData.email, formData.password);
      if (result.success) {
        // Si hay cotización pública guardada, redirigir a crear envío
        var cotizacionPublica = sessionStorage.getItem('cotizacion_publica');
        if (cotizacionPublica) {
          window.location.href = '/crear-envio';
        } else {
          window.location.href = '/cotizar?registro=exitoso';
        }
      } else {
        navigate('/login');
      }
    } catch (error) {
      setError(error.response?.data?.error || 'Error al crear la cuenta. Intenta de nuevo.');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #1a1a2e 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: isMobile ? '1.5rem 1rem' : '2rem'
    }}>
      
      {/* Logo */}
      <div 
        style={{ 
          cursor: 'pointer', 
          marginBottom: isMobile ? '0.5rem' : '1rem',
          backgroundColor: 'white',
          borderRadius: '1rem',
          padding: '0.5rem 1.5rem'
        }} 
        onClick={() => navigate('/')}
      >
        <img 
          src="/logo.png" 
          alt="EnvíaTuPaquete" 
          style={{ height: isMobile ? '5rem' : '7rem' }} 
        />
      </div>

      {/* Main Card */}
      <div style={{
        width: '100%',
        maxWidth: '420px',
        backgroundColor: 'white',
        borderRadius: '1rem',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        overflow: 'hidden'
      }}>
        
        {/* Orange accent bar */}
        <div style={{ height: '4px', background: 'linear-gradient(90deg, #ff8c00, #ff6b00)' }} />

        <div style={{ padding: isMobile ? '1.5rem 1.25rem' : '2rem 2rem' }}>
          
          {/* Headline - Benefit oriented */}
          <h1 style={{
            fontSize: isMobile ? '1.25rem' : '1.4rem',
            fontWeight: '700',
            color: '#111827',
            marginBottom: '0.5rem',
            lineHeight: 1.3,
            textAlign: 'center'
          }}>
            Cotiza tus envíos con tarifas especiales
          </h1>

          {/* Trust badges - inline */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: isMobile ? '0.5rem' : '0.75rem',
            marginBottom: '1.5rem',
            flexWrap: 'wrap'
          }}>
            {[
              { icon: '⚡', text: '30 segundos' },
              { icon: '🆓', text: 'Gratis' },
              { icon: '💳', text: 'Sin tarjeta' }
            ].map((badge, i) => (
              <span key={i} style={{
                fontSize: '0.75rem',
                color: '#6b7280',
                backgroundColor: '#f3f4f6',
                padding: '0.25rem 0.6rem',
                borderRadius: '9999px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.25rem'
              }}>
                {badge.icon} {badge.text}
              </span>
            ))}
          </div>

          {/* Error */}
          {error && (
            <div style={{
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              color: '#991b1b',
              padding: '0.625rem 0.75rem',
              borderRadius: '0.5rem',
              marginBottom: '1rem',
              fontSize: '0.85rem',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gap: '0.875rem' }}>
              
              {/* Nombre */}
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '0.3rem'
                }}>Nombre</label>
                <input
                  name="nombre"
                  type="text"
                  required
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder="Tu nombre"
                  autoComplete="name"
                  style={{
                    width: '100%',
                    padding: '0.7rem 0.875rem',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '0.5rem',
                    fontSize: '1rem',
                    boxSizing: 'border-box',
                    transition: 'border-color 0.2s',
                    outline: 'none',
                    backgroundColor: '#fafafa'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#ff8c00'}
                  onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                />
              </div>

              {/* Email */}
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '0.3rem'
                }}>Email</label>
                <input
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="tu@email.com"
                  autoComplete="email"
                  style={{
                    width: '100%',
                    padding: '0.7rem 0.875rem',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '0.5rem',
                    fontSize: '1rem',
                    boxSizing: 'border-box',
                    transition: 'border-color 0.2s',
                    outline: 'none',
                    backgroundColor: '#fafafa'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#ff8c00'}
                  onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                />
              </div>

              {/* Teléfono */}
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '0.3rem'
                }}>Teléfono</label>
                <input
                  name="telefono"
                  type="tel"
                  required
                  value={formData.telefono}
                  onChange={handleChange}
                  placeholder="10 dígitos"
                  autoComplete="tel"
                  inputMode="numeric"
                  maxLength={10}
                  pattern="[0-9]{10}"
                  style={{
                    width: '100%',
                    padding: '0.7rem 0.875rem',
                    border: '1.5px solid #e5e7eb',
                    borderRadius: '0.5rem',
                    fontSize: '1rem',
                    boxSizing: 'border-box',
                    transition: 'border-color 0.2s',
                    outline: 'none',
                    backgroundColor: '#fafafa'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#ff8c00'}
                  onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                />
              </div>

              {/* Password */}
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '0.3rem'
                }}>Contraseña</label>
                <div style={{ position: 'relative' }}>
                  <input
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    required
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Mínimo 6 caracteres"
                    autoComplete="new-password"
                    style={{
                      width: '100%',
                      padding: '0.7rem 2.5rem 0.7rem 0.875rem',
                      border: '1.5px solid #e5e7eb',
                      borderRadius: '0.5rem',
                      fontSize: '1rem',
                      boxSizing: 'border-box',
                      transition: 'border-color 0.2s',
                      outline: 'none',
                      backgroundColor: '#fafafa'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#ff8c00'}
                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '0.75rem',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '1.1rem',
                      color: '#9ca3af',
                      padding: '0.25rem'
                    }}
                  >
                    {showPassword ? '🙈' : '👁️'}
                  </button>
                </div>
              </div>

              {/* CTA Button */}
              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '0.875rem',
                  background: loading ? '#ccc' : 'linear-gradient(135deg, #ff8c00, #ff6b00)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.5rem',
                  fontWeight: '700',
                  fontSize: '1.05rem',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  marginTop: '0.25rem',
                  boxShadow: loading ? 'none' : '0 4px 14px rgba(255,140,0,0.4)',
                  transition: 'transform 0.1s, box-shadow 0.2s',
                  letterSpacing: '0.01em'
                }}
                onMouseDown={(e) => { if (!loading) e.target.style.transform = 'scale(0.98)'; }}
                onMouseUp={(e) => { e.target.style.transform = 'scale(1)'; }}
              >
                {loading ? 'Creando cuenta...' : 'Crear cuenta y cotizar →'}
              </button>
            </div>
          </form>

          {/* Microcopy trust signals */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '1rem',
            marginTop: '0.875rem',
            flexWrap: 'wrap'
          }}>
            {[
              '🔒 Datos protegidos',
              '🚫 Sin compromisos'
            ].map((text, i) => (
              <span key={i} style={{ fontSize: '0.7rem', color: '#9ca3af' }}>{text}</span>
            ))}
          </div>

          {/* Login link */}
          <div style={{ textAlign: 'center', marginTop: '1.25rem', paddingTop: '1rem', borderTop: '1px solid #f3f4f6' }}>
            <span style={{ fontSize: '0.85rem', color: '#6b7280' }}>
              ¿Ya tienes cuenta?{' '}
              <span
                onClick={() => navigate('/login')}
                style={{ color: '#ff8c00', fontWeight: '600', cursor: 'pointer' }}
              >
                Inicia sesión
              </span>
            </span>
          </div>
        </div>
      </div>

      {/* Credibility block below card */}
      <div style={{
        maxWidth: '420px',
        width: '100%',
        marginTop: '1.5rem',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: isMobile ? '0.5rem' : '0.75rem',
        textAlign: 'center'
      }}>
        {[
          { icon: '📦', text: 'Especialistas en paquetes grandes' },
          { icon: '💰', text: 'Tarifas competitivas' },
          { icon: '⚡', text: 'Sin intermediarios' }
        ].map((item, i) => (
          <div key={i} style={{
            backgroundColor: 'rgba(255,255,255,0.08)',
            borderRadius: '0.5rem',
            padding: isMobile ? '0.625rem 0.25rem' : '0.75rem 0.5rem',
            backdropFilter: 'blur(10px)'
          }}>
            <div style={{ fontSize: isMobile ? '1.25rem' : '1.5rem', marginBottom: '0.25rem' }}>{item.icon}</div>
            <div style={{ fontSize: isMobile ? '0.6rem' : '0.7rem', color: 'rgba(255,255,255,0.7)', lineHeight: 1.3 }}>{item.text}</div>
          </div>
        ))}
      </div>

      {/* Paqueterias logos */}
      <div style={{
        marginTop: '1.25rem',
        display: 'flex',
        justifyContent: 'center',
        gap: isMobile ? '0.75rem' : '1.5rem',
        flexWrap: 'wrap'
      }}>
        {['Paquetexpress', 'DHL', 'Estafeta'].map((paq, i) => (
          <span key={i} style={{
            fontSize: isMobile ? '0.65rem' : '0.75rem',
            color: 'rgba(255,255,255,0.4)',
            fontWeight: '600',
            letterSpacing: '0.05em',
            textTransform: 'uppercase'
          }}>{paq}</span>
        ))}
      </div>
    </div>
  );
}

export default Registro;